import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ExchangeRate', {
    exchangeRateText: '1 {baseCurrency} = {rate} {currency}',
    xeroSyncDisclaimer: 'Will be synced with Xero after final approval if there are differences.',
});
